// Nidra Theme Global Utilities
(function() {
  'use strict';

  function smoothScrollTo(targetEl, offset) {
    if (!targetEl) return;
    var header = document.querySelector('.site-header');
    var headerHeight = header ? header.offsetHeight : 60;
    var targetOffset = offset !== undefined ? offset : (headerHeight + 12);

    var getTargetY = function() {
      return Math.round(targetEl.getBoundingClientRect().top + window.pageYOffset - targetOffset);
    };

    window.scrollTo({
      top: getTargetY(),
      behavior: 'smooth'
    });

    // Compensate for content-visibility / lazy section expansion during scrolling on mobile
    var checkDelays = [250, 600, 1000, 1500];
    checkDelays.forEach(function(delay) {
      setTimeout(function() {
        var rect = targetEl.getBoundingClientRect();
        var diff = rect.top - targetOffset;
        if (Math.abs(diff) > 20) {
          window.scrollTo({
            top: Math.round(window.pageYOffset + diff),
            behavior: 'smooth'
          });
        }
      }, delay);
    });
  }

  // Smooth anchor link scrolling & Review Navigation Handler
  document.addEventListener('click', function(e) {
    var target = e.target.closest('a[href^="#"]');
    if (!target) return;
    var hash = target.getAttribute('href');
    if (!hash || hash === '#' || hash.length <= 1) return;

    var isReviewNav = (hash === '#customer-reviews' || hash === '#reviews');
    if (isReviewNav) {
      var source = 'unknown';
      if (target.id === 'PdpReviewsBadgeLink' || target.closest('.pdp-reviews-badge-link')) {
        source = 'pdp_summary';
      } else if (target.id === 'HeroReviewsBadgeLink' || target.closest('.hero-reviews-badge-link')) {
        source = 'hero_summary';
      } else if (target.id === 'CarouselAllReviewsLink' || target.closest('.carousel-all-reviews-link')) {
        source = 'carousel_all_reviews';
      }

      if (typeof window.clarity === 'function') {
        window.clarity('event', 'review_link_clicked');
        window.clarity('set', 'review_click_source', source);
      }
    }

    // BUG 1 FIX: For review links, scroll to the precise review-cards anchor
    // with layout-shift compensation for lazy sections.
    var el;
    if (isReviewNav) {
      el = document.getElementById('ReviewCardsStart') || document.getElementById('customer-reviews') || document.querySelector('[data-section-type="customer-reviews"]');
    } else {
      el = document.querySelector(hash);
    }

    if (!el && isReviewNav) {
      el = document.getElementById('customer-reviews') || document.getElementById('reviews') || document.querySelector('[data-section-type="customer-reviews"]');
    }

    if (el) {
      e.preventDefault();
      smoothScrollTo(el, 72);

      // Accessibility focus management — focus the heading of the review section
      var reviewSection = document.getElementById('customer-reviews');
      var heading = reviewSection ? (reviewSection.querySelector('h1, h2, h3, [tabindex="-1"]') || reviewSection) : el;
      if (heading && typeof heading.focus === 'function') {
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }

      if (history.pushState) {
        history.pushState(null, null, '#customer-reviews');
      }
    }
  });

  // Track click on "All 76 reviews & photos" and header Reviews links
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href="/pages/reviews"], a[href*="/reviews"]');
    if (!link) return;
    if (typeof window.clarity === 'function') {
      var source = 'reviews_page_link';
      if (link.closest('header') || link.classList.contains('nav-link')) {
        source = 'header_nav';
      } else if (link.id === 'CarouselAllReviewsLink' || link.closest('.reviews-carousel-section')) {
        source = 'carousel_link';
      }
      window.clarity('event', 'reviews_page_visited');
      window.clarity('set', 'reviews_nav_origin', source);
    }
  });

  // FAQ Accordions
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.faq-accordion-header');
    if (!btn) return;

    var item = btn.closest('.faq-accordion-item');
    if (!item) return;

    var content = item.querySelector('.faq-accordion-content');
    var icon = btn.querySelector('.faq-icon');
    var isExpanded = btn.getAttribute('aria-expanded') === 'true';

    btn.setAttribute('aria-expanded', !isExpanded);
    if (content) {
      content.style.display = isExpanded ? 'none' : 'block';
    }
    if (icon) {
      icon.style.transform = isExpanded ? 'rotate(0deg)' : 'rotate(45deg)';
    }
  });

  // Intersection Observer for scroll animations
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.scroll-in').forEach(function(el) {
      observer.observe(el);
    });
  }

  // ==========================================================================
  // ==========================================================================
  // Customer Photo Review Lightbox Modal — TASK 17 FIX
  // Full prev/next navigation, keyboard, swipe, accessibility, and counter.
  // ==========================================================================
  var photoModal = document.getElementById('CustomerPhotoModal');
  var modalImg = document.getElementById('ModalPhotoImage');
  var modalQuote = document.getElementById('ModalPhotoQuote');
  var modalAuthor = document.getElementById('ModalPhotoAuthor');
  var modalCounter = document.getElementById('ModalPhotoCounter');
  var closeBtn = document.getElementById('ClosePhotoModalBtn');
  var prevBtn = document.getElementById('ModalPrevBtn');
  var nextBtn = document.getElementById('ModalNextBtn');
  var backdropDismiss = document.getElementById('ModalBackdropDismiss');

  // Ensure modal is a direct child of document.body to avoid containing block/content-visibility clipping
  if (photoModal && photoModal.parentNode !== document.body) {
    document.body.appendChild(photoModal);
  }

  // Collect all photo buttons into an ordered array for navigation
  var allPhotoButtons = [];
  var currentPhotoIndex = 0;
  var openerElement = null; // The element that opened the modal, for focus restoration
  var savedModalScrollY = 0;

  function collectPhotoButtons() {
    allPhotoButtons = Array.prototype.slice.call(
      document.querySelectorAll('.customer-photo-zoom-btn')
    );
  }

  function updateModalContent(index) {
    if (index < 0 || index >= allPhotoButtons.length) return;
    currentPhotoIndex = index;
    var btn = allPhotoButtons[index];

    var src = btn.getAttribute('data-photo-src');
    var alt = btn.getAttribute('data-photo-alt') || 'Customer photo enlarged';
    var quote = btn.getAttribute('data-quote') || '';
    var author = btn.getAttribute('data-author') || 'Verified Customer Review';

    if (modalImg) {
      modalImg.src = src;
      modalImg.alt = alt;
    }
    if (modalQuote) modalQuote.textContent = '\u201C' + quote.replace(/^[\u201C\u201D"]+|[\u201C\u201D"]+$/g, '') + '\u201D';
    if (modalAuthor) modalAuthor.textContent = author;
    if (modalCounter) modalCounter.textContent = (index + 1) + ' / ' + allPhotoButtons.length;

    updateNavButtons();
  }

  function updateNavButtons() {
    var isFirst = currentPhotoIndex === 0;
    var isLast = currentPhotoIndex >= allPhotoButtons.length - 1;

    if (prevBtn) {
      prevBtn.style.opacity = isFirst ? '0.35' : '1';
      prevBtn.style.cursor = isFirst ? 'not-allowed' : 'pointer';
      prevBtn.disabled = isFirst;
      prevBtn.setAttribute('aria-disabled', isFirst ? 'true' : 'false');
    }
    if (nextBtn) {
      nextBtn.style.opacity = isLast ? '0.35' : '1';
      nextBtn.style.cursor = isLast ? 'not-allowed' : 'pointer';
      nextBtn.disabled = isLast;
      nextBtn.setAttribute('aria-disabled', isLast ? 'true' : 'false');
    }
  }

  function openPhotoModal(btn) {
    if (!photoModal || !modalImg) return;
    collectPhotoButtons();

    savedModalScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

    // Determine the index of the clicked button
    var idx = allPhotoButtons.indexOf(btn);
    if (idx === -1) idx = 0;

    openerElement = btn;
    updateModalContent(idx);

    photoModal.style.display = 'flex';
    photoModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    if (closeBtn) closeBtn.focus();

    if (typeof window.clarity === 'function') {
      window.clarity('event', 'customer_photo_zoomed');
      window.clarity('set', 'photo_index', String(idx));
    }
  }

  function closePhotoModal() {
    if (!photoModal) return;
    photoModal.style.display = 'none';
    photoModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    window.scrollTo(0, savedModalScrollY);

    // Restore focus to the button that opened the modal
    if (openerElement && typeof openerElement.focus === 'function') {
      openerElement.focus({ preventScroll: true });
    }
    openerElement = null;
  }

  function navigatePhoto(direction) {
    var newIndex = currentPhotoIndex + direction;
    if (newIndex < 0 || newIndex >= allPhotoButtons.length) return;
    updateModalContent(newIndex);

    if (typeof window.clarity === 'function') {
      window.clarity('event', 'lightbox_navigate');
      window.clarity('set', 'lightbox_direction', direction > 0 ? 'next' : 'prev');
    }
  }

  // Direct element event listeners for maximum reliability
  if (closeBtn) {
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closePhotoModal();
    });
  }
  if (prevBtn) {
    prevBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      navigatePhoto(-1);
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      navigatePhoto(1);
    });
  }
  if (backdropDismiss) {
    backdropDismiss.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closePhotoModal();
    });
  }

  // Delegated click handler on document for any dynamically rendered buttons
  document.addEventListener('click', function(e) {
    var zoomBtn = e.target.closest('.customer-photo-zoom-btn');
    if (zoomBtn) {
      e.preventDefault();
      openPhotoModal(zoomBtn);
      return;
    }

    if (e.target.closest('#ClosePhotoModalBtn')) {
      e.preventDefault();
      closePhotoModal();
      return;
    }

    if (e.target.closest('#ModalPrevBtn')) {
      e.preventDefault();
      navigatePhoto(-1);
      return;
    }

    if (e.target.closest('#ModalNextBtn')) {
      e.preventDefault();
      navigatePhoto(1);
      return;
    }

    if (e.target === backdropDismiss || (photoModal && e.target === photoModal)) {
      e.preventDefault();
      closePhotoModal();
    }
  });

  // Keyboard handlers: Escape, ArrowLeft, ArrowRight
  document.addEventListener('keydown', function(e) {
    if (!photoModal || photoModal.style.display !== 'flex') return;

    if (e.key === 'Escape') {
      e.preventDefault();
      closePhotoModal();
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      navigatePhoto(-1);
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      navigatePhoto(1);
    }
  });

  // Mobile touch swipe support
  if (photoModal) {
    var touchStartX = 0;
    var touchStartY = 0;
    var touchMoved = false;
    var touchIsOnButton = false;

    photoModal.addEventListener('touchstart', function(e) {
      if (e.touches.length !== 1) return;
      touchIsOnButton = !!e.target.closest('button');
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchMoved = false;
    }, { passive: true });

    photoModal.addEventListener('touchmove', function(e) {
      touchMoved = true;
    }, { passive: true });

    photoModal.addEventListener('touchend', function(e) {
      if (!touchMoved || touchIsOnButton) return;
      var touchEndX = e.changedTouches[0].clientX;
      var touchEndY = e.changedTouches[0].clientY;
      var dx = touchEndX - touchStartX;
      var dy = touchEndY - touchStartY;

      // Swipe left = Next, Swipe right = Previous
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) {
        if (dx < 0) {
          navigatePhoto(1);
        } else {
          navigatePhoto(-1);
        }
      }
    }, { passive: true });
  }
})();
